/**
 * Archetypes (layer on top of the 6 core modes)
 *
 * These are not additional core modes. They are readable summaries derived from blends.
 * Each archetype is defined as a weighted mix of the 6 modes.
 */

export const archetypes = [
  {
    id: 'leader',
    title: 'Leader',
    description:
      'You align people around a clear direction and keep the team moving. You combine vision with communication and ownership.',
    weights: { visionary: 0.6, relationshipBuilder: 0.6, strategist: 0.3, executor: 0.2 },
    focus: 'Set a single weekly outcome and make ownership explicit.',
    watchOut: 'Avoid keeping things vague to maintain harmony. Make decisions concrete.',
  },
  {
    id: 'caregiver',
    title: 'Caregiver',
    description:
      'You protect energy, relationships, and culture. You build trust and stability so the team can perform over time.',
    weights: { relationshipBuilder: 0.8, analyst: 0.3, executor: 0.2 },
    focus: 'Create clear expectations and one hard conversation you have been avoiding.',
    watchOut: 'Do not avoid conflict when clarity is needed.',
  },
  {
    id: 'builder',
    title: 'Builder',
    description:
      'You turn priorities into systems and steady progress. You build repeatable execution that compounds.',
    weights: { executor: 0.8, strategist: 0.4, analyst: 0.2 },
    focus: 'Pick one constraint and build a simple weekly scoreboard.',
    watchOut: 'Do not ship fast without validating the "why".',
  },
  {
    id: 'operator',
    title: 'Operator',
    description:
      'You run clean operations and reduce chaos. You make decisions with evidence and deliver with discipline.',
    weights: { executor: 0.7, analyst: 0.7, strategist: 0.2 },
    focus: 'Timebox analysis and commit to the smallest next step.',
    watchOut: 'Avoid getting stuck in analysis or process.',
  },
  {
    id: 'strategic-mind',
    title: 'Strategic mind',
    description:
      'You see the game clearly and choose the right battles. You spot positioning, risks, and sequencing.',
    weights: { strategist: 0.8, analyst: 0.5, visionary: 0.2 },
    focus: 'Choose one wedge and ship something that makes it real this week.',
    watchOut: 'Avoid over-planning. Use a weekly shipping cadence.',
  },
  {
    id: 'experimenter',
    title: 'Experimenter',
    description:
      'You learn through fast tests. You explore new options and unlock novel solutions under uncertainty.',
    weights: { innovator: 0.8, visionary: 0.4, analyst: 0.1 },
    focus: 'Run one experiment end to end with a clear pass or fail.',
    watchOut: 'Avoid splitting focus across too many ideas.',
  },
  {
    id: 'connector',
    title: 'Connector',
    description:
      'You create momentum through relationships. You win by building trust, partnerships, and alignment.',
    weights: { relationshipBuilder: 0.9, visionary: 0.2, innovator: 0.2 },
    focus: 'Do five warm outreaches and ask for referrals after value is delivered.',
    watchOut: 'Avoid saying yes to everything. Protect deep work time.',
  },
];

export const getArchetypeById = (id) => archetypes.find((a) => a.id === id) || null;

